module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_0024_blue_jean.db6e86f5.jpg";